import { Star } from "lucide-react";

// Permanent badge for the first 50 Xcelio partners — shown in the Hub and on everything they share.
export default function FoundingBadge({ className = "", testId = "founding-badge" }) {
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border border-amber-300/40 bg-amber-300/[0.08] px-2.5 py-0.5 text-[10px] uppercase tracking-[0.18em] text-amber-200 ${className}`} data-testid={testId}>
      <Star className="w-3 h-3" fill="currentColor" /> Founding Partner
    </span>
  );
}
